module.exports = __webpack_public_path__ + "img/hr.756fd3f6.svg";